export const PAYMENT_METHOD_CASH = 2
export const PAYMENT_METHOD_ONLINE = 1
export const PAYMENT_METHOD_WITH_TERMINAL = 3
